<script setup lang="ts">
import { getDateTimeFormatted } from '@/components/formatters/utils';
import { computed } from 'vue';
import { EMPTY_FIELD_SIGN } from '@/components/forms/utils.ts';
import TimeStamp from '@/components/EntityHistory/components/TimeStamp.vue';
import { EntityChangeEvent, entityChangeIcons } from './entityChange';

const props = withDefaults(
  defineProps<{
    entityChange?: EntityChangeEvent;
    singleLine?: boolean;
    showEmptyFieldSign?: boolean;
  }>(),
  {
    entityChange: undefined,
    singleLine: false,
    showEmptyFieldSign: true,
  },
);

const formattedTime = computed(() =>
  getDateTimeFormatted({
    value: props.entityChange?.time,
  }),
);
</script>

<template>
  <span
    :class="{ 'entity-change--multiLine': !singleLine }"
    data-testid="entityChange"
    :type="entityChange?.type"
  >
    <span v-if="entityChange?.user && singleLine" data-testid="entityChange_edited"
      >{{ $t('EditedSinceBy', { since: formattedTime, user: entityChange.user }) }}
    </span>

    <TimeStamp
      v-else-if="entityChange"
      :user="entityChange.user"
      :time="entityChange.time"
      :icon="entityChangeIcons[entityChange.type]"
      :singleLine="singleLine"
    />

    <span v-else-if="!entityChange && showEmptyFieldSign">
      {{ EMPTY_FIELD_SIGN }}
    </span>
  </span>
</template>

<style lang="scss" scoped>
.entity-change--multiLine {
  display: flex;
  flex-direction: column;
}
</style>
